(ns ui.animation-editor.register
  "UI register of the animation editor slice: the Replicant story
   template editor under /ui/animation-editor and its action handlers."
  (:require [ui.animation-editor.actions :as actions]
            [ui.animation-editor.page :as page]))

(def register
  (concat [page/page]
          actions/handlers))
